import _ from 'lodash';
import select2 from '../../mixins/select2';
import {GLOBAL_SCOPE} from '../../../shared/constants/vee_validate';

export default{
  props: {
    searchable: {
      type: Boolean,
      default: false
    },
    validationScope: {
      default: GLOBAL_SCOPE
    }
  },
  mounted: mounted,
  computed: {
    $config: $config
  },
  methods: {
    selection: selection
  },
  mixins: [select2]
}

function mounted(){
  let scope = this;

  scope.selectElement
    .on('select2:select', onSelect)
    .on('select2:opening select2:closing', onToggling)
    .on('select2:unselecting', onUnselecting)
    .on('select2:open', onOpen)
    .on('select2:close', onClose);

  function onSelect(event){
    scope.$nextTick(() => {
      scope.triggeredByClick = true;
      scope.selectElement.val([event.params.data.id]).trigger('change');
      scope.triggeredByClick = null;
    });
  }

  function onToggling() {
    if(scope.searchable) return;
    let searchField = $(this).parent().find('.select2-search__field');
    searchField.prop('disabled', true);
  }

  function onUnselecting(event){
    let isFromSearchField = !event.params.args.originalEvent;
    if(isFromSearchField) return;

    event.preventDefault();

    scope.selectElement.select2('close');
  }

  function onOpen(){
    switchIcon('glyphicon-chevron-down', 'glyphicon-chevron-up');
  }

  function onClose(){
    switchIcon('glyphicon-chevron-up', 'glyphicon-chevron-down');
  }

  function switchIcon(from, to){
    $(scope.$refs.icon).removeClass(from).addClass(to);
  }
}

function $config(){
  return _.assign(this.config, {
    multiple: true,
    width: '100%'
  });
}

function selection(data){
  let selected = _.find(data, {selected: true}) || _.head(data);
  return selected ? {value: selected.id, option: selected} : {value: '', option: selected};
}